
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/summer-er-bootcamp",
      function () {
        return require("private-next-pages/special/summer-er-bootcamp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/summer-er-bootcamp"])
      });
    }
  